<template>
  <div>
    <ASelect
             v-model="input"
             class="w-full"
             @change="search"
             placehoder="مقدار"
    >
      <ASelectOption v-for="(i,k) in items" :key="k">
        {{ i }}
      </ASelectOption>
    </ASelect>
  </div>
</template>

<script>
export default {
  name: 'SelectXTableFilter',
  props: ['value', 'items'],
  data() {
    return {
      input: undefined
    }
  },
  methods: {
    search() {
      this.$emit('input', this.input)
    },
  },
  mounted() {
    this.input = this.value
  }
}
</script>
